export default "__VITE_PUBLIC_ASSET__de4f3266__"